"use client";

import { useEffect, useRef, useState, type ReactNode } from "react";
import styles from "./sidebar.module.css";

/**
 * 更新ブログ・アーカイブ・広告をまとめて追従させる。childrenを返し、DBにはアクセスしない。
 * PCで上下16pxの余白を含む全体が収まる場合だけ有効化し、低い画面やタブレットでは通常表示する。
 * リサイズと内容の高さを監視する副作用があり、アンマウント時に解除する。例外は投げない。
 */
export default function StickySidebarGroup({ children }: { children: ReactNode }) {
	const groupRef = useRef<HTMLDivElement>(null);
	const [canStick, setCanStick] = useState(false);

	useEffect(() => {
		const group = groupRef.current;
		if (!group) return;
		const desktop = window.matchMedia("(min-width: 1024px) and (hover: hover) and (pointer: fine)");
		/** 読み取りだけで全体の高さを比較し、広告の切り取りやスクロールに伴う再配信を防ぐ。 */
		const sync = () => {
			setCanStick(desktop.matches && group.getBoundingClientRect().height <= window.innerHeight - 32);
		};
		const observer = new ResizeObserver(sync);
		observer.observe(group);
		window.addEventListener("resize", sync);
		desktop.addEventListener("change", sync);
		sync();
		return () => {
			observer.disconnect();
			window.removeEventListener("resize", sync);
			desktop.removeEventListener("change", sync);
		};
	}, []);

	return (
		<div ref={groupRef} className={styles.stickyGroup} data-sticky={canStick ? "true" : "false"}>
			{children}
		</div>
	);
}
